import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconVikingdealsBlack({
	size = "100",
	...props
}: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="evenodd" strokeWidth={0.8}>
				<path
					stroke="#000"
					strokeLinecap="round"
					d="M8.338 5.15s1.432.92 1.138 3.414c-.285 2.409-3.414 4.248-3.414 7.313 0 2.451 0 3.984 3.863 3.984l2.663.001m.585-14.696s-.569.597-1.406-.016c-.859-.63-2.007-1.532-3.429 0"
				/>
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					d="m10.898 17.744 1.707-5.852m-3.414 0 1.707 5.852m-1.991-4.319h3.982m-3.698 1.532h3.413"
				/>
				<path
					stroke="#000"
					d="M9.476 7.617h2.56M9.191 9.44h3.129m5.403 7.356c.002.613-1.42.92-2.559.92-1.142 0-2.56-.307-2.56-.92s1.418-.92 2.56-.92c1.138 0 2.559.356 2.559.92zm.001 1.533c0 .613-1.137.919-2.555.919-1.427 0-2.564-.225-2.564-.92m0-1.532v1.587m5.118 0V16.84m0 2.714c0 .92-1.136 1.226-2.559 1.226-1.41 0-2.56-.306-2.56-1.226m.001-1.188v1.188m5.118 0v-1.188"
				/>
				<path
					stroke="#000"
					strokeLinecap="round"
					d="M13.173 5.166s-1.69.957-1.137 3.355c.564 2.452 3.698 4.29 3.698 7.356"
				/>
			</g>
		</svg>
	);
}
